import { z } from 'zod/v4'
import { assetConditionSchema, buildingTypeSchema } from '../assets/assetDataTypes.ts'

export type PropertyFiltersCoreType =
  | 'buildingType'
  | 'condition'
  | 'price'
  | 'size'
  | 'rooms'
  | 'year'

export const validatedPropertyFilterSchema = z.object({
  buildingTypes: z.array(buildingTypeSchema).min(1),
  conditions: z.array(assetConditionSchema).optional(),
  priceMin: z.number().optional(),
  priceMax: z.number(),
  sizeMin: z.number(),
  sizeMax: z.number().optional(),
  roomsMin: z.number(),
  roomsMax: z.number().optional(),
  buildYearMin: z.string().optional(),
  buildYearMax: z.string().optional(),
})

export type ValidatedPropertyFilterSchema = z.infer<typeof validatedPropertyFilterSchema>

export const interestFilterFields: Record<
  PropertyFiltersCoreType,
  (keyof ValidatedPropertyFilterSchema)[]
> = {
  buildingType: ['buildingTypes'],
  condition: ['conditions'],
  price: ['priceMin', 'priceMax'],
  size: ['sizeMin', 'sizeMax'],
  rooms: ['roomsMin', 'roomsMax'],
  year: ['buildYearMin', 'buildYearMax'],
}

export const propertyFilterSchema = validatedPropertyFilterSchema.partial()
export type PropertyFiltersType = z.infer<typeof propertyFilterSchema>

export const defaultFilters: Partial<PropertyFiltersType> = {
  buildingTypes: [],
  conditions: [],
  priceMax: undefined,
  sizeMin: undefined,
  sizeMax: undefined,
  roomsMin: undefined,
}
